import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Distributors from "./Distributors";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";

function DistributorNetworkPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
             sx={{
               display: {
                 xs: "block",
                 sm: "block",
                 md: "none",
               },
             }}
           >
             <AppHeader />
           </MDBox>
      <Distributors subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default DistributorNetworkPage;
